import {
    MarketAllowance,
    OutcomeAllowance,
} from './types';

export function createAllowancesKey(marketAId: number, marketBId: number) {
    return marketAId < marketBId ? `${marketAId}_${marketBId}` : `${marketBId}_${marketAId}`;
}

export function mergeToExistingAllowances<T extends MarketAllowance | OutcomeAllowance>(
    currentAllowances: Record<string, Set<T>>,
    allowancesToAdd: T[],
    key: string,
): Set<T> {
    const newAllowances = new Set(currentAllowances[key] ?? []);
    allowancesToAdd.forEach((allowance) => {
        newAllowances.add(allowance);
    });
    return newAllowances;
}
